exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".totalField-38c36{font-weight:700;color:#595959;position:absolute;top:0px;left:52%}", ""]);

// Exports
exports.locals = {
	"totalField": "totalField-38c36"
};